import { dropdownValues } from '@interfaces/common.model';
import { PositionData } from '@interfaces/open-positions.model';

export const uniqueValues = (data: PositionData[], key: keyof PositionData) => {
  const values = data?.flatMap((item) => {
    const value = item[key];
    return Array.isArray(value) ? value : [value];
  });
  return [...new Set(values)];
};

export const createOptions = (
  data: PositionData[],
  key: keyof PositionData,
): dropdownValues[] => {
  return uniqueValues(data, key)?.map((value) => ({
    label: value as string,
    value: value as string,
  }));
};

export const createVendorOptions = (
  data: PositionData[],
  key: keyof PositionData,
): dropdownValues[] => {
   const values = uniqueValues(data, key)
    ?.flatMap((value) =>
      (value as string)
        .split(',')
        .map((v) => v.trim())
    );
  const uniqueVendors = [...new Set(values)];
  return uniqueVendors.map((value) => ({
    label: value,
    value: value,
  }));
};

export const createLocationOptions = (data: PositionData[]) => {
  const locations = uniqueValues(data, 'location')
    ?.flatMap((value) => (value as string)?.split(','))
    ?.map((value) => value?.trim());
  const uniqueLocations = [...new Set(locations)];
  return uniqueLocations?.map((value) => ({ label: value, value }));
};
